import React, { useState } from 'react';
import MyEquipments from './MyEquipments';
import Rentequipment from './RentEquipmentTab';
import EquipmentRequests from './EquipmentRequestsTab';

const CreatorEquipments = () => {
  const [activeTab, setActiveTab] = useState('inventory');

  const tabs = [
    { id: 'inventory', label: 'Your Equipment' },
    { id: 'rent', label: 'Request For Equipment' },
    { id: 'requests', label: 'Your Requests' },
  ];

  return (
    <div className="p-4 md:p-6 min-h-screen dark:bg-dark-grey transition-colors duration-300">
      <div className="mb-4 md:mb-6">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Equipment Hub</h1>
        <p className="text-gray-500 dark:text-zinc-400 text-sm mt-1">
          Manage your inventory, browse gear, and track requests.
        </p>
      </div>

      {/* TAB NAVIGATION */}
      <div className="flex border-b border-[#E8DDD3] dark:border-zinc-800 mb-0 md:mb-6 gap-8">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`pb-3 text-sm font-medium transition-colors relative ${
              activeTab === tab.id
                ? 'text-golden border-b-2 border-golden'
                : 'text-gray-500 dark:text-zinc-400 hover:text-gray-700 dark:hover:text-white'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* TAB CONTENT */}
      <div className="mt-4">
        {activeTab === 'inventory' && <MyEquipments />}
        {activeTab === 'rent' && <Rentequipment />}
        {activeTab === 'requests' && <EquipmentRequests />}
      </div>
    </div>
  );
};

export default CreatorEquipments;
